const preAuthTransactionPaths = {
  PRE_AUTH_TRANSACTION: '',
  SEARCH_PRE_AUTH_TRANSACTION: 'search',
  PRE_AUTH_TRANSACTION_ID: (id) => id,
  SEARCH_PRE_AUTH_TRANSACTION_LIST : (venueId) => `venue/${venueId}`,
};

export default preAuthTransactionPaths;
